export const fragenPrivaterAutoverkaufKaufvertrag = [
  {
    question: "Ist ein mündlicher Kaufvertrag gültig?",
    answer: (
      <>
        <p>
          Ja, aber nur schwer beweisbar. Schriftliche Verträge sind immer
          sicherer.
        </p>
      </>
    ),
  },
  {
    question: "Darf ich den Kaufvertrag per E-Mail oder digital abschließen?",
    answer: (
      <>
        <p>
          Ja, sofern beide Parteien zustimmen und unterschreiben – idealerweise
          mit Scan oder Foto der Signatur.
        </p>
      </>
    ),
  },
  {
    question: "Reicht eine Kopie des Vertrags für Käufer und Verkäufer?",
    answer: (
      <>
        <p>Ja, beide sollten ein unterschriebenes Exemplar behalten.</p>
      </>
    ),
  },
  {
    question: "Was, wenn der Käufer nicht bezahlt?",
    answer: (
      <>
        <p>
          Das Auto bleibt dein Eigentum, bis der volle Kaufpreis überwiesen ist.
          Übergabe erst nach Zahlung.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich die Gewährleistung im Vertrag ausschließen?",
    answer: (
      <>
        <p>
          Ja, als Privatperson ist das erlaubt – Formulierung siehe oben.
        </p>
      </>
    ),
  },
];
